var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFyldLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fyld Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-1.1-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-nav",
    transform: "translate(-16.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "brand/Mark/all-backgrounds",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mark"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF308",
    fillRule: "nonzero",
    x: -9.09494702e-15,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#151515",
    fillRule: "nonzero",
    points: "22.4 32 26.24 32 26.24 26.24 32 26.24 32 22.4 26.24 22.4 26.24 18.56 32 18.56 32 14.72 22.4 14.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#151515",
    fillRule: "nonzero",
    points: "7.04 32 10.88 32 10.88 10.88 14.72 10.88 14.72 32 18.56 32 18.56 10.88 32 10.88 32 7.04 7.04 7.04"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyldLogo);
export default __webpack_public_path__ + "static/media/fyld-logo.42fe7c718740a6638e233d5ee4934e24.svg";
export { ForwardRef as ReactComponent };